let monitoringInitialized = false;

export const reportClientError = (payload) => {
    if (!import.meta.env.PROD) return;
    const body = JSON.stringify({ ...payload, path: window.location.href });
    if (navigator.sendBeacon) {
        navigator.sendBeacon('/api/client-error.php', new Blob([body], { type: 'application/json' }));
        return;
    }
    fetch('/api/client-error.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
    }).catch(() => {});
};

export const initializeMonitoring = () => {
    if (monitoringInitialized || typeof window === 'undefined') return;
    monitoringInitialized = true;

    window.addEventListener('error', (event) => {
        reportClientError({
            message: event.message || 'Unknown window error',
            source: event.filename || '',
            line: event.lineno || 0,
            column: event.colno || 0,
        });
    });

    window.addEventListener('unhandledrejection', (event) => {
        const reason = event.reason;
        reportClientError({
            message: reason instanceof Error ? reason.message : String(reason || 'Unhandled promise rejection'),
            source: 'unhandledrejection',
        });
    });
};
